import { z } from 'zod';

const FINDING_TYPES = ['nonconformity_major', 'nonconformity_minor', 'observation', 'opportunity'];

const LEGACY_FINDING_TYPES = {
    major_nc: 'nonconformity_major',
    minor_nc: 'nonconformity_minor',
};

/** Map stale client keys to model SoT (`assessment`, model type enum). */
export function normalizeAuditFindingInput(data) {
    if (!data || typeof data !== 'object' || Array.isArray(data)) return data;
    const next = { ...data };
    if (next.assessment == null && next.assessmentId != null) {
        next.assessment = next.assessmentId;
    }
    delete next.assessmentId;
    if (next.control == null && next.controlId != null) {
        next.control = next.controlId;
    }
    delete next.controlId;
    if (typeof next.type === 'string' && LEGACY_FINDING_TYPES[next.type]) {
        next.type = LEGACY_FINDING_TYPES[next.type];
    }
    return next;
}

export const AuditFindingSchema = z.object({
    id: z.string().optional(),
    assessment: z.string().min(1),
    questionId: z.string().optional(),
    control: z.string().optional(),
    title: z.string().min(1),
    description: z.string().optional(),
    type: z.enum(FINDING_TYPES),
    status: z.string().default('open'),
    relatedCorrectiveActionId: z.string().optional(),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});
export const CreateAuditFindingSchema = z.preprocess(
    normalizeAuditFindingInput,
    AuditFindingSchema.omit({ id: true, createdAt: true, updatedAt: true })
);
export const UpdateAuditFindingSchema = z.preprocess(
    normalizeAuditFindingInput,
    AuditFindingSchema.partial()
);
